// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"Templates_cardTitle__ksZ7m","cardDesc":"Templates_cardDesc__VC_Xp","card":"Templates_card__lSyRR","single":"Templates_single__EBKp_"};